import { json } from 'app/utils';
import { ILookup } from 'app/models';

interface ILookupOptions {
  path: string;
  params?: Record<string, any>;

  map: (data: any) => ILookup;
}

export enum ELookup {
  clients = 'clients',
  countries = 'countries',
  languages = 'languages',
  pages = 'pages',
  professions = 'professions',
  roles = 'roles',
  subscriptions = 'subscriptions',
  users = 'users',
}

export const options: Record<string, ILookupOptions> = {
  [ELookup.clients]: { path: 'clients',
    map: ({ id, name }) => ({ value: id, label: name }),
  },
  [ELookup.countries]: { path: 'countries',
    map: ({ id, name }) => ({ value: id, label: name }),
  },
  [ELookup.languages]: { path: 'languages',
    map: ({ id, name, code }) => ({ value: id, label: name, code }),
  },
  [ELookup.professions]: { path: 'professions',
    map: ({ id, name, type }) => ({ value: id, label: name, type }),
  },
  [ELookup.roles]: { path: 'roles',
    map: ({ id, name }) => ({ value: id, label: name }),
  },
  [ELookup.subscriptions]: { path: 'subscriptions',
    map: ({ id, name }) => ({ value: id, label: name }),
  },
  [ELookup.users]: { path: 'users',
    map: ({ id, username }) => ({ value: id, label: username }),
  },
};

const comparer = (a: any, b: any) => a.path.localeCompare(b.path);

export const utils = Object.seal({
  encode: (key: string, params?: any): any => {
    const map = json.nodes(params ?? {}, '$..*').sort(comparer);
    if (!map.length) return key;

    const variant = json.encode(json.build(map));

    return `${key}#${variant}`;
  },

  decode: (name: string): [string, any] => {
    const [key, variant] = name.split('#');

    return [key, (variant ? json.decode(variant) : undefined)];
  },
});
